module.exports = __webpack_public_path__ + "img/design-2.89655264.png";